angular.module('gym.availability').factory('EditAvailabilityService', ["$modal", "$stateParams", "Availability", function($modal, $stateParams, Availability) {
  return {
    getNewAvailabilityBlock: function(start_time_obj = new Date(), end_time_obj = new Date()) {
      return {
        appointment_type_ids: [],
        location_id: void 0,
        start_time: moment(start_time_obj).format('HHmm'),
        start_time_obj: start_time_obj,
        end_time: moment(end_time_obj).format('HHmm'),
        end_time_obj: end_time_obj,
        available: true,
        event_buffer_minutes: 0,
        id: null,
        trainer_availability_override_id: void 0
      };
    },
    confirmRemove: function(trainerAvailability) {
      var modalInstance;
      modalInstance = $modal.open({
        template: require('templates/components/profile/confirmDeleteAvailabilityModal.html.slim'),
        controller: ["$scope", "$modalInstance", function($scope, $modalInstance) {
          $scope.submit = function() {
            return $modalInstance.close();
          };
          return $scope.cancel = function() {
            return $modalInstance.dismiss('cancel');
          };
        }],
        resolve: {
          trainerAvailability: function() {
            return trainerAvailability;
          }
        }
      });
      return modalInstance.result;
    },
    removeAvailability: function(isRecurring, slot, availabilityBlocks) {
      var date, editType, trainerAvailability;
      editType = isRecurring ? 'recurring' : 'single';
      date = slot.availability_date;
      availabilityBlocks = _.chain(availabilityBlocks).map(function(item) {
        if (item.id === slot.id) {
          if (isRecurring) {
            return void 0;
          } else {
            item.available = false;
          }
        }
        return item;
      }).compact().value();
      trainerAvailability = {
        user_id: $stateParams.userId || window.currentUser.id,
        current_date: date,
        edit_type: editType,
        trainer_availability_blocks: availabilityBlocks
      };
      return this.validate(trainerAvailability).then(function() {
        return Availability.post(trainerAvailability);
      }, (response) => {
        trainerAvailability.errors = response.data;
        return this.confirmRemove(trainerAvailability).then(function() {
          return Availability.post(trainerAvailability);
        });
      });
    },
    validate: function(trainerAvailability) {
      var params;
      params = {
        withoutNamespace: true,
        trainer_availability: trainerAvailability
      };
      return Availability.doPOST(params, 'validate');
    }
  };
}]);
